/* eslint-disable */
import Vue from "vue";
import Vuex from "vuex";
import payments from "./components/payments/store";
import partners_payments from "./components/partners-payments/store";
import deposits from "./components/deposits/store";
import user from "./components/user/store";
import dashboard from "./components/dashboard/store";
import tickets from "./components/tickets/store";
import account from "./components/account/store";
import wallet from "./components/desktop/wallet/store";
import bills from "./components/desktop/bills/store";
import invoices from "./components/invoices/store";
import chargebacks from "./components/chargebacks/store";
import recharges from "./components/desktop/recharges/store";
import partners from "./components/desktop/partners/store";
import login from "./components/login/store";
import system from "./components/system/store";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production" || process.env.NODE_ENV !== "staging";

export default new Vuex.Store({
  strict: debug,
  modules: {
    payments,
    deposits,
    partners_payments,
    user,
    dashboard,
    tickets,
    account,
    wallet,
    bills,
    invoices,
    chargebacks,
    recharges,
    partners,
    login,
    system
  }
});
